<template>
    <div class="app" :class="bDown ? 'app-overflow' : ''">
        <div class="header">
            <div class="left">
                <div class="item" :class="{'item-active':item.select}" v-for="(item, index) in searchConf.tab"
                    :key="item.code" @click="fastSearch(index, 0)">{{ item.name }}</div>
                <div class="item" :class="{'item-active':item.select}" v-for="(item, index) in searchConf.brand"
                    :key="item.code" @click="fastSearch(index, 1)">{{ item.name }}</div>
                <div class="item" @click="toAntMap">冷暖风水</div>
                <!-- <div class="item" @click="toCommercial">商用净水</div> -->
            </div>
            <div class="right">
                <img class="search-icon" src="@/assets/images/household/serch.png" alt="">
                <div class="search-text" @click="getShow">搜索案例</div>
            </div>
        </div>
        <!-- 搜索弹框 -->
        <div class="search" v-show="bShow">
            <div class="close-t" @click="getShow"></div>
            <div class="search-box">
                <div class="input-box goods-wrap">
                    <label>产品型号</label>
                    <div class="goods-content">
                        <input type="text" placeholder="输入产品型号搜索" @input="inputChange" @focus='focusing' @blur="blue" v-model="proType" placeholder-class="place" />
                        <div class="content" v-show="isShowSelectType">
                            <van-list class="data-content" v-if="arrGoods.length" @load="onLoadType" offset="0" :loading="isLoading" :finished="isFinish" finished-text="没有更多了">
                                <div class="item" v-for="item in arrGoods" @mousedown="selectGoodName(item.goods_name)" :key="item.id">{{item.goods_name}}</div>
                            </van-list>
                            <div class="error" v-else>暂无数据</div>
                        </div>
                    </div>
                </div>
                <div class="input-box">
                    <label>小区名称</label>
                    <input type="text" placeholder="输入小区名称或关键字" v-model="rqname" placeholder-class="place" />
                </div>
                <div class="tag-box">
                    <label>案例类型</label>
                    <div class="list">
                        <template v-if="!allCase">
                            <div class="list-item" :class="{ active: item.select }"
                                @click="setSearchConfKey('topic_type', index)"
                                v-for="(item, index) in searchConf.topic_type" :key="index">{{ item.name }}</div>
                        </template>
                        <div class="list-item" :class="{ active: allCase }" @click="selectAllCase()">全部案例</div>
                    </div>
                </div>

                <div class="tag-box">
                    <label>产品品类</label>
                    <div class="list">
                        <template v-if="!allCategory">
                            <div class="list-item" :class="{ active: item.select }"
                                @click="setSearchConfKey('cate', index)" v-for="(item, index) in searchConf.cate"
                                :key="index">{{ item.name }}</div>
                        </template>
                        <div :class="{ active: allCategory }" class="tag list-item" @click="selectAllCategory">全部</div>
                    </div>
                </div>
                <div class="footer-btn">
                    <p class="clone" @click="bShow = false">取消</p>
                    <p class="active" @click="getseash(true)">确定</p>
                </div>

            </div>
        </div>

        <!-- 选择品类 -->
        <div class="popue" v-if="bDown">
            <div class="catcent" @click.stop="getbDown"></div>
            <div class="category">
                <div class="ocrolll">
                    <ul>
                        <li v-for="(item, index) in getlistserd" :key="index"
                            @click.stop="getcateg(item.cate_name, item.id)">
                            {{ item.cate_name }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 案例列表 -->
        <div class="caselist" :style="{ 'padding-top': searchConf.tab.length > 4 ? '50px' : '' }">
            <pull-to :top-load-method="downRefresh" :bottom-load-method="upRefresh" :top-config="TOP_DEFAULT_CONFIG"
                :bottom-config="BOTTOM_DEFAULT_CONFIG" :is-bottom-bounce="true" bottom-block-height:0
                top-block-height:0>
                <ul class="wrap">
                    <li v-for="(item, index) in caseList" :key="index">
                        <caseItem :itemInfo='item' @showMore="showMore" :index='index' @collectClick="collectClick"
                            @showSharePopup="showSharePopup"></caseItem>
                        <div class="share-box" v-if="item.share_float" @click.stop="item.share_float = false">
                            <div class="share-list">
                                <p class="icon-share" @click.stop="gosarelink(item)">
                                    <span>直接转发分享</span>
                                    <img src="@/assets/images/case/icon_wechat.png" />
                                </p>
                                <p class="icon-img" @click.stop="gosarea(item)">
                                    <span>添加活动分享</span>
                                    <img src="@/assets/images/case/icon_wechat.png" />
                                </p>
                            </div>
                        </div>
                    </li>
                    <div class="dropload-tip" v-if="bhow">我是有底线的</div>
                </ul>
            </pull-to>
            <div class="tips" v-if="from == 'shopping' && nTips">
                <div class="del" @click="getDel"></div>
                <div class="title">温馨提示</div>
                <div class="text">
                    很遗憾，本地无该型号案例，切换至全国/一键上传
                </div>
            </div>
        </div>
        <!-- 二级联动 -->
        <awesome-picker ref="picker" :anchor="anchor" :data="address" colorConfirm="#576b95" colorCancel="#969799"
            swipeTime:500 @cancel="handlePickerCancel" @confirm="handlePickerConfirm" v-if="bPicker"></awesome-picker>
        <div class="sidebar">
            <div class="address" @click="show">
                <img class="address-icon" src="@/assets/images/household/address.png" alt="">
                <div class="address-text">{{ city ? city : "请选择" }}</div>
            </div>
            <div class="switch">
                <div class="map-switch switch-item" @click.stop="gocasemap">
                    <img class="map-icon" src="@/assets/images/household/map.png" alt="">
                    <div class="map-text">地图<br />模式</div>
                </div>
                <div class="switch-item" @click.stop="orderPopup">
                    <img class="map-icon" src="@/assets/images/household/order.png" alt="">
                    <div class="map-text">排序</div>
                </div>
            </div>
        </div>
        <div class="baidu_click">
            <div class="baidu_item green" @click="getClickWindom(1)">
                               <img src="@/assets/images/case/home_icon.png" alt="">
                商城咨询
            </div>
            <div class="baidu_item wilith" @click="getClickWindom(2)">
                               <img src="@/assets/images/case/kefu_icon.png" alt="">
                免费设计<br />报名
            </div>
        </div>
        <!-- 排序选择 -->
        <van-popup v-model:show="isShowPicker" round position="bottom">
            <van-picker confirm-button-text='确认' cancel-button-text="取消" :columns="columns" @confirm="onConfirm"
                :show-toolbar='true' @cancel="onCancel" />
        </van-popup>

        <div class="video-float" v-if="viewVideoSrc">
            <div class="close" @click="viewVideoSrc = ''">
                <img src="@/assets/images/case/icon_close.png" />
            </div>
            <video :src="viewVideoSrc" width="100%" height="auto" controls="controls" id="video"></video>
        </div>
        <iframe v-if="citySelectShow" id="mapPage" width="100%" height="100%" frameborder=0
            src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&policy=1&key=UW3BZ-J2JRA-XXIKC-CGQBX-ZC4Y6-NJFB5&referer=aosms">
        </iframe>
       <awesome-picker ref="popupPicker" :anchor="arrProvince" :data="arrProvinceVlue" colorConfirm="#576b95" colorCancel="#969799"
            swipeTime:500 @cancel="popupCancel" @confirm="popupConfirm" v-if="isAddress"></awesome-picker>
        <div class="info-all" v-if="isPopup">
            <div class="info-box">
                <div class="popup_top"><img src="@/assets/images/user/popup/popup_top.png" /></div>
                <!-- 姓名 -->
                <div class="name-box">
                    <div class="name-title">姓名：</div>
                    <input class="name-input" v-model="name" placeholder="请输入姓名" onfocus="this.placeholder=''" onblur="this.placeholder='请输入姓名'"/>
                </div>
                <!-- 电话 -->
                <div class="name-box">
                    <div class="name-title">电话：</div>
                    <input class="name-input" v-model="phone" placeholder="请输入电话" onfocus="this.placeholder=''" onblur="this.placeholder='请输入电话'"/>
                </div>
                <div class="address-title">地址:</div>
                <!-- 省市区 -->
                <div class="address-box" @click="changeAddess">
                    <div class="province">{{popupProvince}}{{popupProvince?'':'省'}}</div>
                    <div class="province">{{popupCity}}{{popupCity?'':'市'}}</div>
                    <div class="province">{{popupDistrict}}{{popupDistrict?'':'区'}}</div>
                </div>
                <!-- 详细地址 -->
                <div class="address-detail">
                    <input class="address-input" v-model="popurAddress" placeholder="请输入您的详细地址" onfocus="this.placeholder=''" onblur="this.placeholder='请输入您的详细地址'"/>
                </div>
                <div class="category-box">
                    <div class="category">品类</div>
                    <div class="category-tips">（品类可多选）</div>
                </div>
                <div class="button-box">
                    <div :class="item.state == 0?'cate-button':'cate-button-item'"
                        v-for="(item,index) in arrPuporCategory" @click="changeCate(item)">
                        <div>{{item.title}}</div>
                    </div>
                </div>
                <div class="signUp" @click="getPush">
                    立即报名
                </div>
                <!-- <div class="tips-box">
                    <div class="tips-title">报名有礼：「美容软水沐浴体验装」</div>
                    <div class="tips-content">深层清洁 强效保湿 滋养发丝</div>
                    <div class="tips-litter">注：安装在花洒下，体验装内附说明书，因纸字版说明书里的二维码已过期，如有需求可咨询官方商城客服。</div>
                </div> -->
            </div>
            <div class="close-icon" @click="changePopur">
                <img class="close-icon-image" src="@/assets/images/user/popup/close_icon.png" />
            </div>
        </div>
    </div>
</template>
<script>
    import path from "@/path.js";
    import {
        requestAesPost5
    } from "@/libsV2/requestAes.js";
    import PullTo from "vue-pull-to";
    import caseItem from "@/components/caseItem/index";
    import loadJs from "@/libs/loadjs.js";
    export default {
        name: "caseV1",
        components: {
            PullTo,
            caseItem,
        },
        data() {
            return {
                citySelectShow: false,
                isShowPicker: false, //排序弹框
                columns: [
                    "收藏量由高到低",
                    "转发量由高到低",
                    "发布时间顺序",
                    "发布时间倒序",
                ],
                allCategory: false,
                anchor: [{
                        index: 0,
                        value: "",
                    },
                    {
                        index: 0,
                        value: "",
                    },
                ], //默认选中
                arrAnchor: [], //初始化默认值
                arrSelect: [],
                bPicker: false,
                bDown: false, //下拉选品类
                bShow: false, //显示隐藏下拉框
                bWhole: false, //选择全部案例
                bMouth: false, //选择口碑案例
                typename: "", //品类
                modelname: "", //型号搜索
                addressShow: true,
                province: "", //省
                city: "", //市
                provinces: "", //省列表
                citys: "", //市列表
                address: [], //地级联动列表
                addressData: [], //未解析的地级联动列表
                addressObj: {
                    province: "",
                    city: "",
                    area_id: "",
                },
                nAddsear: 0, //0城市,1关键词,2城市+关键词
                TOP_DEFAULT_CONFIG: {
                    pullText: "下拉刷新", // 下拉时显示的文字
                    triggerText: "释放更新", // 下拉到触发距离时显示的文字
                    loadingText: "加载中...", // 加载中的文字
                    doneText: "加载完成", // 加载完成的文字
                    failText: "加载失败", // 加载失败的文字
                    loadedStayTime: 400, // 加载完后停留的时间ms
                    stayDistance: 50, // 触发刷新后停留的距离
                    triggerDistance: 70, // 下拉刷新触发的距离
                },
                BOTTOM_DEFAULT_CONFIG: {
                    pullText: "加载中...",
                    triggerText: "加载中...",
                    loadingText: "加载中...",
                    doneText: "加载中...",
                    failText: "加载中...",
                    loadedStayTime: 0,
                    stayDistance: 10,
                    triggerDistance: 10,
                    bShowloading: true,
                },
                objList: "", //省市id
                caseList: [], //案例列表
                imgArr: [], //户型图片
                getlistserd: [], //品类选择
                parent_id: "", //商品分类id
                nGindex: "", //0为全部，1为口碑
                page: 0, //页码
                loading: false,
                bhow: false,
                latitude: "", //精度
                longitude: "", //纬度
                nAldSource:"",
                arrImg: [],
                from: "", //商品详情来源
                nTips: false,

                sortFloat: false,

                // 搜索配置文件
                rqname: "", //小区名字搜索
                proType: "",
                searchConf: {
                    house_area: [],
                    cate: [],
                    topic_type: [],
                    tab: [],
                    brand: [],
                    goods_type: [],
                },
                tab: "",
                sort: {
                    time_desc: 0,
                    time_asc: 0,
                    shares: 0,
                    collect_num: 0,
                },
                userinfo: {}, //用户信息

                // 查看的视频
                viewVideoSrc: "",
                allCase: false,
                cityRouter: "",
                provinceyRouter: "",
                longitudeyRouter: "",
                latitudeyRouter: "",
                arrGoods: [], //产品类型
                proTypePage: 0, //产品分页
                isShowSelectType: false, //是否展示产品型号选择框
                isFinish: false, //是否加载完产品所有数据
                isLoading: false, //产品类型加载更多loading
                isPopup: false, //显示弹窗
                isAddress: false, //三级地址选择
                arrPuporCategory: [{
                        id: 1,
                        title: '热水器',
                        state: 0
                    },
                    {
                        id: 2,
                        title: '烟机',
                        state: 0
                    },
                    {
                        id: 3,
                        title: '净水机',
                        state: 0
                    },
                    {
                        id: 4,
                        title: '冷暖风水',
                        state: 0
                    },
                    {
                        id: 5,
                        title: '其它',
                        state: 0
                    },
                ],
                name: '',
                phone: '',
                popupProvince: '',
                popupCity: '',
                popupDistrict: '',
                popurAddress: '',
                type: [],
                arrProvince: [],
                arrProvinceVlue:[]
            };
        },
        watch: {
            viewVideoSrc(val) {
                if (val) {
                    this.$nextTick(() => {
                        let video = document.getElementById("video");
                        video.play();
                    });
                }
            },
        },
        async created() {
            // this.getNewLocation();
            // this.getMyLocation();
            this.city = this.$storage.getStorage('city');
            this.province = this.$storage.getStorage('province');
            this.latitude = this.$storage.getStorage('latitude');
            this.longitude = this.$storage.getStorage('longitude');
            this.nAldSource = this.$route.query.ald_source;
            if (!this.longitude) {
                const {
                    city,
                    lat,
                    lng,
                    province
                } = await this.getUserLocation();
                this.$storage.setStorage('city', city);
                this.$storage.setStorage('province', province);
                this.$storage.setStorage('latitude', lat);
                this.$storage.setStorage('longitude', lng);
                this.city = city;
                this.province = province;
                this.latitude = lat;
                this.longitude = lng;
            }

            this.parent_id = this.$route.query.parentid;
            this.modelname = this.$route.query.model;
            this.from = this.$route.query.from; //商品详情来源
            this.$store.commit("loadSwitch", true);
            if (this.modelname) {
                this.proType = this.modelname;
            }
            // console.log("--->", this.$route.query);
            // path.post5(path.topicGetConf).then((res) => {
            requestAesPost5("topic/aes/getConf").then((res) => {
                if (res.data.error == 0) {
                    for (let key in res.data.data.result) {
                        let item = res.data.data.result[key];
                        for (let subitem of item) {
                            subitem.select = false;
                        }
                    }
                    // res.data.data.result.brand.forEach(it=>{
                    //     res.data.data.result.tab.push(it)
                    // })
                    if (this.parent_id) {
                        let arrParent = res.data.data.result.cate.filter((it) => {
                            return it.code == this.parent_id;
                        });
                        arrParent[0].select = true;
                    }
                    // console.log(res.data.data.result);
                    this.searchConf = res.data.data.result;
                } else {
                    this.$toast({
                        message: res.data.msg,
                        duration: 1200,
                    });
                }
            });
            Promise.all([this.arrgoAddress()]).then(() => {});
        },
        mounted() {
            this.$nextTick(() => {
                this.getTree()
                // 百度数据统计
                // _hmt.push(['_trackPageview', '/case/map/v2/lists']);
            });
        },

        methods: {
            //确定
            popupConfirm: function(e)  {
                this.popupProvince = e[0].value
                this.popupCity = e[1].value
                this.popupDistrict = e[2].value
                this.isAddress = false
            },
            //取消
            popupCancel() {
                this.isAddress = false
            },
            //地址弹窗选项显示
            changeAddess() {
                this.isAddress = true;
                setTimeout(() => {
                    this.$refs.popupPicker.show();
                }, 200);
            },
            //关闭弹窗
            changePopur() {
                this.isPopup = false
            },
            //点击品类多选
            changeCate(item) {
                item.state = item.state ? 0 : 1
                let arrType = []
                this.arrPuporCategory.forEach(it => {
                    if (it.state) {
                        arrType.push(it.title)
                    }
                })
                console.log(arrType)
                this.type = arrType
            },
            //立即报名，数据上传接口
            aaaaaa(){
                console.log(this.nAldSource,'000')
            },
            getPush() {
                if(this.name==''){
                    this.$toast("请输入姓名", {
                        duration: 1500,
                    });
                    return
                }
                if(this.phone==''){
                    this.$toast("请输入电话", {
                        duration: 1500,
                    });
                    return
                }
                if(this.popupProvince==''||this.popupCity==''||this.popupDistrict==''){
                    this.$toast("请选择省市区", {
                        duration: 1500,
                    });
                    return
                }
                if(this.type == ''){
                    this.$toast("请选择品类", {
                        duration: 1500,
                    });
                    return
                }
                requestAesPost5("topic/free/push",{
                    name: this.name,
                    phone: this.phone,
                    province: this.popupProvince,
                    city: this.popupCity,
                    district: this.popupDistrict,
                    address: this.popurAddress,
                    type: this.type.join(','),
                    resource: this.nAldSource,
                }).then((res) => {
                    this.$toast({
                        message: res.data.data.result,
                        // position: "bottom",
                        duration: 1200,
                    });
                    this.isPopup = false
                })
                console.log(this.nAldSource)
            },
            // 获取地址三级联动数据
            getTree() {
                requestAesPost5("comm/district/gettree").then((res) => {
                    let arrTree = res.data.data.result;
                    let arrProvince = arrTree[0];
                    let arrAddress = [];
                    arrProvince.forEach((it) => {
                        let children = [];
                        arrTree[it.id].forEach(is=>{
                            let minChildren = [];
                            if(arrTree[is.id]?.length && is.id != 0){
                                arrTree[is.id].forEach(ia=>{
                                    if(ia.id != 0){
                                        minChildren.push({value:ia.name,id:ia.id})
                                    }
                                })
                            }
                            children.push({value:is.name,id:is.id,children:minChildren})
                        })
                        arrAddress.push({value:it.name,id:it.id,children:children})
                    });
                    this.arrProvinceVlue = arrAddress;
                    console.log(this.arrProvinceVlue)
                });
            },
            // 百度统计跳转链接
            getClickWindom(type) {
                switch (type) {
                    case 1:
                        let source = 'shop_h5list';
                        if(this.$route.query.ald_source){
                            source = 'shop_'+ this.$route.query.ald_source;
                        }
                        _hmt.push(['_trackEvent', source, source, source]);
                        window.location.href =
                            'https://shop.m.jd.com/?shopId=1000001098'
                        break;
                    case 2:
                        this.isPopup = true
                        // _hmt.push(['_trackEvent', 'service', 'service', 'my_service']);
                        // window.location.href =
                        //     'https://shop44173018.youzan.com/v3/im/index?c=wsc&kdt_id=43980850&reft=1656483619010&spm=f.101239334#/index'
                        break;
                }
            },
            /**
             * 获取位置信息
             */
            getUserLocation() {
                // this.$store.commit("loadSwitch", true);
                return new Promise((resolve, reject) => {
                    this.$store.commit("loadSwitch", true);
                    loadJs(
                        "https://apis.map.qq.com/tools/geolocation/min?key=UW3BZ-J2JRA-XXIKC-CGQBX-ZC4Y6-NJFB5&referer=asmH5"
                    ).then((res) => {
                        const TX_KEY = "UW3BZ-J2JRA-XXIKC-CGQBX-ZC4Y6-NJFB5";
                        const geolocation = new qq.maps.Geolocation(
                            TX_KEY,
                            "asmH5", {
                                timeout: 2000,
                                failTipFlag: true
                            }
                        );
                        geolocation.getLocation(
                            (result) => {
                                this.$store.commit("loadSwitch", false);
                                console.log(result, "位置信息");
                                // 保存当前地理坐标
                                this.$storage.setStorage("userPosition", result);
                                resolve(result);
                                // 获取成功
                            },
                            () => {
                                this.$toast({
                                    message: "自动定位失败请手动确认位置信息",
                                    forbidClick: true,
                                    onClose: () => {
                                        this.$store.commit("loadSwitch", false);
                                        this.citySelectShow = true;
                                        window.addEventListener(
                                            "message",
                                            (event) => {
                                                // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
                                                const loc = event.data;
                                                if (
                                                    loc &&
                                                    loc.module === "locationPicker"
                                                ) {
                                                    //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
                                                    const {
                                                        cityname,
                                                        latlng: {
                                                            lat,
                                                            lng
                                                        },
                                                        poiaddress,
                                                    } = loc;
                                                    this.city = cityname;
                                                    this.province = poiaddress
                                                        .split("省").length != 1 ?
                                                        poiaddress.split("省")[0] +
                                                        "省" : poiaddress.split("市")[
                                                            0] + "市";
                                                    this.latitude = lat;
                                                    this.longitude = lng;
                                                    this.$storage.setStorage('city',
                                                        cityname);
                                                    this.$storage.setStorage(
                                                        'province', poiaddress
                                                        .split("省").length !=
                                                        1 ? poiaddress.split(
                                                            "省")[0] +
                                                        "省" : poiaddress.split(
                                                            "市")[0] + "市");
                                                    this.$storage.setStorage(
                                                        'latitude', lat);
                                                    this.$storage.setStorage(
                                                        'longitude', lng);
                                                    this.citySelectShow = false;
                                                    this.arrgoAddress();
                                                    // this.initPage(false);
                                                    //再次调用分享
                                                    // this.wxShare();
                                                    // 保存当前地理坐标
                                                    this.$storage.setStorage(
                                                        "userPosition",
                                                        loc
                                                    );
                                                }
                                            },
                                            false
                                        );
                                    },
                                });
                            }
                        );
                    });
                });
            },
            // 上拉加载更多
            onLoadType() {
                if (this.arrGoods.length >= 20) {
                    this.proTypePage++;
                    this.getGoods();
                }
            },
            // 选择产品型号
            selectGoodName(name) {
                this.proType = name;
            },
            // 监听产品型号input输入
            inputChange() {
                this.isFinish = false;
                this.proTypePage = 0;
                this.arrGoods = [];
                this.getGoods();
            },
            // 产品型号input框聚焦
            focusing() {
                this.isShowSelectType = true;
            },
            blue() {
                this.isShowSelectType = false;
            },
            // 获取产品型号
            getGoods() {
                this.isLoading = true;
                requestAesPost5("topic/aes/searchGoods", {
                    word: this.proType ? this.proType : "",
                    page: this.proTypePage,
                    limit: 20,
                }).then((res) => {
                    this.isLoading = false;
                    if (res.data.error == 0) {
                        if (
                            this.proTypePage != 0 &&
                            res.data.data.result.length < 20
                        ) {
                            this.isFinish = true;
                            return false;
                        }
                        let arr = this.arrGoods.concat(res.data.data.result);
                        this.arrGoods = arr;
                        console.log(this.arrGoods);
                    }
                });
            },
            // 点击收藏
            collectClick(e) {
                this.collection(e.item);
            },
            // 点击分享
            showSharePopup(e) {
                this.caseList.forEach((i) => {
                    if (i.id == e.item.id) {
                        i.share_float = true;
                    }
                });
            },
            // 查看更多
            showMore(e) {
                this.goDetails(e.id, e.isnew, e.item);
            },
            // 点击排序
            orderPopup() {
                this.isShowPicker = !this.isShowPicker;
                this.bPicker = false;
            },
            // 排序取消
            onCancel() {
                this.isShowPicker = !this.isShowPicker;
            },
            // 排序确认
            onConfirm(e) {
                if (e == "收藏量由高到低") {
                    this.sortList("collect_num");
                } else if (e == "转发量由高到低") {
                    this.sortList("shares");
                } else if (e == "发布时间顺序") {
                    this.sortList("time_asc");
                } else if (e == "发布时间倒序") {
                    this.sortList("time_desc");
                }
                this.isShowPicker = false;
            },
            selectAllCategory() {
                this.allCategory = !this.allCategory;
                this.searchConf.cate.forEach((item) => (item.select = false));
            },
            toAntMap() {
                wx.miniProgram.redirectTo({
                    url: "/pages/ant_map/index/index"
                });
            },
            toCommercial() {
                wx.miniProgram.redirectTo({
                    url: "/pages/business/map/index"
                });
            },
            selectAllCase() {
                if (this.allCase) {
                    for (let item of this.searchConf.topic_type) {
                        item.select = false;
                    }
                } else {
                    for (let item of this.searchConf.topic_type) {
                        item.select = true;
                    }
                }
                this.allCase = !this.allCase;
            },
            fastSearch(index, num) {
                if (num == 0) {
                    this.searchConf.tab.forEach((it, i) => {
                        if (index == i) {
                            it.select = !it.select;
                        } else {
                            it.select = false;
                        }
                    });
                } else if (num == 1) {
                    this.searchConf.brand.forEach((it, i) => {
                        if (index == i) {
                            it.select = !it.select;
                        } else {
                            it.select = false;
                        }
                    });
                }
                this.page = 0;
                this.bhow = false;
                this.caseList = [];
                this.bShow = false;
                this.getCaselist(true);
            },
            setSearchConfKey(key, index) {
                if (key == "cate" && this.searchConf[key][index].code == 0) {
                    if (this.searchConf[key][index].select) {
                        this.searchConf[key].forEach((it, nIt) => {
                            if (it.code != 0) {
                                it.select = false;
                            }
                        });
                    } else {
                        this.searchConf[key].forEach((it, nIt) => {
                            if (it.code != 0) {
                                it.select = true;
                            }
                        });
                    }
                    this.searchConf[key][index].select = !this.searchConf[key][index].select;
                } else {
                    this.searchConf[key].forEach((it, nIt) => {
                        // console.log(it);
                        if (it.code == 0) {
                            it.select = false;
                        }
                    });
                    this.searchConf[key][index].select = !this.searchConf[key][index].select;
                }
            },
            //跳转直接分享
            gosarelink(item) {
                this.$store.commit("loadSwitch", true);
                path.post5(path.getUser, {
                    user_id: this.$route.query.tp5Userid,
                }).then((res) => {
                    // console.log("用户信息", res);
                    this.userinfo = res.data.data.result;
                    this.$store.commit("loadSwitch", false);
                    //判断是否为直销员  ==0  不是直销员
                    if (this.userinfo.sell_id == 0) {
                        //  this.$toast({
                        //   message: "您不是直销员",
                        //   duration: 500,
                        // });
                        // setTimeout(() => {
                        wx.miniProgram.navigateTo({
                            url: `/pages/phoneauth/index?url=/pages/case/share/index&userid=${this.$route.query.userid}&topicid=${item.id}`,
                        });
                        // }, 500);
                    } else {
                        wx.miniProgram.navigateTo({
                            url: `/pages/case/share/index?userid=${this.$route.query.userid}&topicid=${item.id}`,
                        });
                    }
                });
            },
            //跳转添加活动页面
            gosarea(item) {
                this.$store.commit("loadSwitch", true);
                path.post5(path.getUser, {
                    user_id: this.$route.query.tp5Userid,
                }).then((res) => {
                    // console.log("用户信息", res);
                    this.userinfo = res.data.data.result;
                    this.$store.commit("loadSwitch", false);
                    //判断是否为直销员  sell_id==0:不是直销员
                    if (this.userinfo.sell_id == 0) {
                        //  this.$toast({
                        //   message: "您不是直销员",
                        //   duration: 500,
                        // });
                        // setTimeout(() => {
                        wx.miniProgram.navigateTo({
                            url: `/pages/phoneauth/index?url=/pages/watersystem/activity/index&userid=${this.$route.query.userid}&topicid=${item.id}&from=case`,
                        });
                        // }, 500);
                    } else {
                        wx.miniProgram.navigateTo({
                            url: `/pages/watersystem/activity/index?userid=${this.$route.query.userid}&topicid=${item.id}&from=case`,
                        });
                    }
                });
            },
            //隐藏未搜索到案例弹窗
            getDel() {
                this.from = "";
                // this.modelname='';
                this.parent_id = "";
                this.nTips = false;
                this.getCaselist(true);
            },
            //显示产品品类窗口
            getbDown() {
                this.bDown = !this.bDown;
            },
            //二级联动
            show() {
                this.bPicker = true;
                setTimeout(() => {
                    this.$refs.picker.show();
                }, 100);
            },
            //跳转小程序发布案例
            gouloadcase() {
                this.$store.commit("loadSwitch", true);
                path.post5(path.getUser, {
                    user_id: this.$route.query.tp5Userid,
                }).then((res) => {
                    // console.log("用户信息", res);
                    this.userinfo = res.data.data.result;
                    this.$store.commit("loadSwitch", false);
                    //判断是否为直销员  ==0  不是直销员
                    if (res.data.data.result.sell_id == 0) {
                        wx.miniProgram.navigateTo({
                            url: `/pages/phoneauth/index?url=/pages/case/case_release_xue1/index&userid=0&topicid=0`,
                        });
                    } else {
                        wx.miniProgram.navigateTo({
                            url: "/pages/case/case_release_xue1/index",
                        });
                    }
                });
            },
            //跳转附近案例
            gocasemap() {
                this.$common.redirect("/case/map/v2/index", {
                    // city: this.city,
                    // province: this.province,
                    // latitude: this.latitude,
                    // longitude: this.longitude
                });
            },
            // 收藏
            collection(item) {
                this.$store.commit("loadSwitch", true);
                path.post5(path.topicCollect, {
                    xid: item.id,
                    type: "topic",
                    title: item.province_name +
                        "-" +
                        item.city_name +
                        "-" +
                        item.address,
                    user_id: this.$route.query.tp5Userid,
                }).then((res) => {
                    this.$store.commit("loadSwitch", false);
                    if (res.data.error == 0) {
                        if (item.is_collect) {
                            --item.collect_num;
                        } else {
                            ++item.collect_num;
                        }
                        item.is_collect = !item.is_collect;
                    } else {
                        this.$toast({
                            message: res.data.msg,
                            duration: 500,
                        });
                    }
                });
            },
            //商品分类
            getlists() {
                let data = {
                    cate_id: 0,
                    source: "xcx",
                    user_id: this.$route.query.userid,
                };
                this.$store.commit("loadSwitch", true);
                path.post5(path.getlists, data).then((res) => {
                    //console.log("品类", res);
                    if (res.data.error == 0) {
                        this.$store.commit("loadSwitch", false);
                        let getlistserd = res.data.data.result;
                        getlistserd = [
                            ...[{
                                cate_name: "不限",
                                id: ""
                            }],
                            ...getlistserd,
                        ];
                        this.getlistserd = getlistserd;
                    } else {
                        this.$store.commit("loadSwitch", false);
                        this.$toast({
                            message: res.data.msg,
                            duration: 1200,
                        });
                    }
                });
            },
            //跳转详情
            goDetails(id, isnew, item) {
                console.log(this.$common);
                // console.log(item);
                //console.log("案例id", id, isnew);
                if (isnew == 0) {
                    wx.miniProgram.navigateTo({
                        url: `/pages/case/case_olddetail_vue/index?topicid=${id}&userid=${this.$route.query.userid}`,
                    });
                } else if (isnew == 1) {
                    this.$common.redirect("/case/map/v2/details", {
                        city: this.$route.query.city,
                        province: this.$route.query.province,
                        latitude: this.$route.query.latitude,
                        longitude: this.$route.query.longitude,
                        topicid: id,
                    });
                }
                item.views++;
            },
            sortList(val) {
                for (let key in this.sort) {
                    this.sort[key] = 0;
                }
                this.sort[val] = 1;
                // console.log(this.sort);
                this.getseash(true);
            },
            //案例搜索
            getseash(from) {
                this.from = from;
                // console.log(from);
                this.page = 0;
                this.bhow = false;
                this.caseList = [];
                this.bShow = false;
                if (this.rqname) {
                    this.nAddsear = 1;
                } else if (!this.rqname) {
                    this.nAddsear = "";
                } else if (this.objList) {
                    this.nAddsear = 0;
                } else if (this.rqname && this.objList) {
                    this.nAddsear = 2;
                }
                this.getCaselist(from);
            },
            //案例列表
            getCaselist(from) {
                // console.log("来源", from);
                this.nTips = false;
                let arr = [];
                for (let item of this.searchConf.house_area) {
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                let area = arr.join(",");
                arr = [];
                let arrBx = this.searchConf.cate.filter((it) => {
                    return it.select && it.code == 0;
                });
                if (arrBx.length) {
                    arr.push(0);
                } else {
                    for (let item of this.searchConf.cate) {
                        if (item.select) {
                            arr.push(item.code);
                        }
                    }
                }
                let parent_id = arr.join(",");
                arr = [];
                for (let item of this.searchConf.brand) {
                    // 案列类型
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                let brand_id = arr.join(",");
                arr = [];
                for (let item of this.searchConf.topic_type) {
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                let type = arr.join(",");
                let data = {
                    style: -1,
                    user_id: this.$route.query.userid,
                    city_id: this.objList.city_id,
                    province_id: this.objList.province_id,
                    // search_address: this.nAddsear,
                    source: "xcx",
                    search_keys: this.rqname,
                    page: this.page,
                    limit: 10,
                    genre: this.nGindex,
                    parent_id: parent_id,
                    brand_id: brand_id,
                    model: this.proType,
                    type: type,
                    order: JSON.stringify(this.sort),
                    area: area,
                };

                if (data.genre == "") {
                    delete data.genre;
                }
                if (data.model == "") {
                    delete data.model;
                }
                if (data.parent_id == "") {
                    delete data.parent_id;
                }
                if (data.search_keys == "") {
                    delete data.search_keys;
                }

                // 快速搜索
                if (typeof from == "boolean") {
                    arr = [];
                    for (let item of this.searchConf.tab) {
                        if (item.select) {
                            arr.push(item.code);
                        }
                    }
                    let subparent_id = arr.join(",");
                    // data.search_keys = "";
                    data.subparent_id = subparent_id;
                    // data.model = "";
                    // data.order = "";
                    // data.area = "";
                }

                // //console.log("搜索", data);
                this.$store.commit("loadSwitch", true);
                // path.post5(path.topicList, data).then((res) => {
                requestAesPost5("topic/aes/lists", data).then((res) => {
                    //   console.log("案例列表", res);
                    if (res.data.error == 0) {
                        let arrCaselist = res.data.data.result.list;
                        arrCaselist.forEach((item) => {
                            item.imgArr = [];
                            item.videoArr = [];
                            item.share_float = false;
                            item.arrCategory = [];
                            if (item.scence.length) {
                                item.scence.forEach((it) => {
                                    if (it.mp4_info) {
                                        if (it.mp4_info.mp4_url) {
                                            item.videoArr.push(it.mp4_info);
                                        }
                                    }
                                });
                                item.scence.forEach((it) => {
                                    if (item.imgArr.length < 9) {
                                        if (it.house_img.length) {
                                            item.imgArr.push(it.house_img[0]);
                                        }
                                    }
                                });
                            }

                            if (item.imgArr.length < 9) {
                                item.scence.forEach((it) => {
                                    if (it.house_img.length) {
                                        it.house_img.forEach((itx, index) => {
                                            if (index > 0) {
                                                item.imgArr.push(itx);
                                            }
                                        });
                                    }
                                });
                            }
                            item.scence.forEach((it) => {
                                if (it.device_info.length) {
                                    it.device_info.forEach((itx, index) => {
                                        item.arrCategory.push(itx);
                                    });
                                }
                            });
                            for (let i = 0; i < item.arrCategory.length; i++) {
                                for (let j = i + 1; j < item.arrCategory.length;) {
                                    if (
                                        item.arrCategory[i].id ===
                                        item.arrCategory[j].id
                                    ) {
                                        //通过属性进行匹配；
                                        item.arrCategory.splice(j, 1); //去除重复的对象；
                                    } else {
                                        j++;
                                    }
                                }
                            }
                        });
                        this.$store.commit("loadSwitch", false);
                        if (this.loading) {
                            if (res.data.data.result.list.length < 10) {
                                this.$toast({
                                    message: "到底啦~",
                                    duration: 800,
                                });
                                this.bhow = true;
                                this.loading = false;
                                this.bShowloading = false;
                                return false;
                            }
                        } else {
                            if (res.data.data.result.list.length == 0) {
                                this.bhow = true;
                                this.loading = false;
                                return false;
                            }
                        }
                        this.caseList = this.caseList.concat(arrCaselist);
                    } else {
                        this.$store.commit("loadSwitch", false);
                        this.$toast({
                            message: res.data.msg,
                            duration: 1200,
                        });
                    }
                });
            },
            //picker点击确定
            handlePickerConfirm: function(e) {
                console.log("确定", e);
                this.bhow = false; // 切换城市时，不需要直接展示“我是有底线的”，而应该等数据获取后再展示是否显示“我是有底线的”
                let that = this;
                that.caseList = [];
                that.page = 0;
                let select = e;
                that.arrSelect = select;
                let addressData = that.addressData;
                let objprovinces = addressData[0].find((item) => {
                    return item.name.indexOf(select[0].value.slice(0, 2)) > -1;
                });
                // //console.log("-->省", objprovinces);
                if (objprovinces) {
                    let objCity = addressData[objprovinces.id].find((item) => {
                        // //console.log('=>provincestest',item.name.indexOf(province.slice(0,2)))
                        return item.name.indexOf(select[1].value.slice(0, 2)) > -1;
                    });
                    let provinceId = objprovinces.id;
                    let cityId = objCity.id;
                    let province = objprovinces.name;
                    let city = objCity.name;
                    let obj = {};
                    obj.city_id = cityId;
                    obj.province_id = provinceId;
                    that.objList = obj;
                    that.bCancel = true;
                    //console.log("-->点击确定",obj)
                    that.city = city;
                    that.province = province;
                    this.$storage.setStorage('city', city);
                    this.$storage.setStorage('province', province);
                    that.getCaselist(true);
                }
            },
            //picker点击取消
            handlePickerCancel: function() {
                let that = this;
                if (that.bCancel) {
                    that.bCancel = false;
                    that.anchor = that.arrSelect;
                } else {
                    that.bCancel = false;
                    // that.anchor = that.anchor;
                }

                this.bPicker = false;
                // that.$refs.picker.show();
                // console.log("点击取消", that.anchor);
            },
            //地级列表
            arrgoAddress: function(callback) {
                var that = this;
                let addressList = [];
                this.$store.commit("loadSwitch", true);
                let promers = function() {
                    return new Promise(function(resolve, reject) {
                        that.$store.commit("loadSwitch", true);
                        that.$http
                            .get(
                                "https://pro-core.babycdn.com/2021/aosmith/lottery/china.json"
                            )
                            .then((res) => {
                                // path.post5(path.getFoorplanCity, {}).then((res) => {
                                if (res.body.error == 0) {
                                    var addressData = res.body.data.result;
                                    that.addressData = addressData;
                                    if (that.province) {
                                        let objprovinces = addressData[0].find(
                                            (item) => {
                                                return (
                                                    item.name.indexOf(
                                                        that.province.slice(0, 2)
                                                    ) > -1
                                                );
                                            }
                                        );
                                        if (objprovinces) {
                                            let objCity = addressData[
                                                objprovinces.id
                                            ].find((item) => {
                                                return (
                                                    item.name.indexOf(
                                                        that.city.slice(0, 2)
                                                    ) > -1
                                                );
                                            });
                                            let province = objprovinces.name;
                                            let provinceId = objprovinces.id;
                                            let city = objCity.name;
                                            let cityId = objCity.id;
                                            let addressIndex = [];
                                            addressIndex[0] =
                                                addressData[0].findIndex((item) => {
                                                    return (
                                                        item.name.indexOf(
                                                            that.province.slice(
                                                                0,
                                                                2
                                                            )
                                                        ) > -1
                                                    );
                                                });
                                            addressIndex[1] = addressData[
                                                objprovinces.id
                                            ].findIndex((item) => {
                                                return (
                                                    item.name.indexOf(
                                                        that.city.slice(0, 2)
                                                    ) > -1
                                                );
                                            });
                                            let obj = {};
                                            obj.city_id = cityId;
                                            obj.province_id = provinceId;
                                            that.objList = obj;
                                            ////console.log("市", city);
                                            //console.log("列表", addressIndex, that.objList);
                                            let anchor = [{
                                                    index: addressIndex[0],
                                                    value: province,
                                                },
                                                {
                                                    index: addressIndex[1],
                                                    value: city,
                                                },
                                            ];
                                            that.anchor = anchor;
                                            that.arrAnchor = anchor;
                                            //         //console.log('anchor',anchor)
                                            that.getCaselist();
                                        } else {
                                            //         ////console.log("-->+++hhhh");
                                            let anchor = [{
                                                    index: 0,
                                                    value: ""
                                                },
                                                {
                                                    index: 0,
                                                    value: ""
                                                },
                                            ];
                                            that.anchor = anchor;
                                            // this.getCaselist();
                                        }
                                    } else {
                                        that.getCaselist();
                                    }
                                    let dataobj = addressData[0];
                                    var addressObj = [];
                                    for (let p = 0; p < dataobj.length; p++) {
                                        var children = [];
                                        let cityId = dataobj[p].id;
                                        for (
                                            let c = 0; c < addressData[cityId].length; c++
                                        ) {
                                            let countyId =
                                                addressData[cityId][c].id;
                                            if (addressData[countyId]) {
                                                var areaList = [];
                                                var areaIdList = [];
                                                for (
                                                    let k = 0; k <
                                                    addressData[countyId].length; k++
                                                ) {
                                                    areaList.push(
                                                        addressData[countyId][k]
                                                    );
                                                    areaIdList.push(
                                                        addressData[countyId][k].id
                                                    );
                                                }
                                            }
                                            let cityObj = {
                                                value: addressData[cityId][c].name,
                                                id: addressData[cityId][c].id,
                                                // areaList: areaList,
                                                // areaIdList: areaIdList,
                                            };
                                            children.push(cityObj);
                                        }
                                        let obj = {
                                            value: dataobj[p].name,
                                            id: dataobj[p].id,
                                            children: children,
                                        };
                                        addressObj.push(obj);
                                    }
                                    addressList = addressObj;
                                    resolve(addressList);
                                    return;
                                }
                            });
                    });
                };
                promers().then((res) => {
                    this.address = res;
                    this.$store.commit("loadSwitch", false);
                    console.log(this.address);
                });
            },
            //下拉
            downRefresh(loaded) {
                this.page = 0;
                this.bhow = false;
                this.caseList = [];
                this.getCaselist(true);
                loaded("done");
            },
            //上拉
            upRefresh(loaded) {
                let page = this.page + 1;
                this.page = page;
                this.getCaselist(true);
                this.loading = true;
                //console.log("2");
                loaded("done");
            },
            //唤起pick
            openCity: function() {},
            //点击搜索案例初始化
            getShow: function() {
                this.bShow = !this.bShow;
                this.bDown = false;
                // this.bWhole = false;
                // this.bMouth = false;
                // this.modelname = "";
                // this.rqname = "";
                // this.typename = "";
            },
            //点击全部案例
            getwhole: function(index) {
                this.nGindex = index;
                this.bWhole = true;
                this.bMouth = false;
            },
            //点击口碑案例
            getmouth: function(index) {
                this.nGindex = index;
                this.bWhole = false;
                this.bMouth = true;
            },
            //获取选择的品类
            getcateg: function(title, id) {
                this.typename = title;
                this.parent_id = id;
                this.bDown = false;
            },
        },
    };
</script>
<style lang="scss" scoped>
    ::v-deep .mask {
        display: none !important;
    }

    ::v-deep .picker {
        position: fixed !important;
        left: 0 !important;
        right: 0 !important;
        // top: 116px !important;
        z-index: 10000 !important;
        background: #fff !important;
        height: 514px !important;
    }

    ::v-deep .picker-title span {
        font-size: 36px !important;
    }

    ::v-deep .picker-title h4 {
        background: #efefef !important;
    }

    ::v-deep .picker-wheel-wrapper .wheel-scroll .wheel-item {
        font-weight: bold !important;
        color: #707274 !important;
    }

    ::v-deep .picker-panel .picker-mask-top:after {
        border-bottom: 2px solid #add !important;
    }

    ::v-deep .picker-panel .picker-mask-bottom:before {
        border-top: 2px solid #add !important;
    }
</style>
<style lang="scss" scoped>
    #mapPage {
        width: 100vw;
        height: 100vh;
        z-index: 9999;
        position: fixed;
        left: 0;
        bottom: 0;
    }

    @import "lists.scss";
</style>
